import {Directive, Input, ElementRef, OnChanges} from '@angular/core';
import {UserMention} from '../data/user-mention';

@Directive({
  selector: '[appUserMentionContent]'
})
export class UserMentionContentDirective implements OnChanges {
  @Input()
  content: string;

  @Input()
  mentions: UserMention[]

  constructor(
    protected el: ElementRef
  ) {
  }

  ngOnChanges() {
    let itemWithMentions = this.content

    if (this.mentions && this.mentions.length > 0) {

      const usersStr = this.mentions
        .map(ment => '@' + ment.user.username)
        .join('|');

      const regStr = new RegExp('(' + usersStr + ')', 'gim');


      // itemWithMentions = itemWithMentions
      // 	.replace(/\s/gim, '&#32;')

      itemWithMentions = itemWithMentions
        .replace(itemWithMentions, '<div class="full-span">' + itemWithMentions + '</div>')

      itemWithMentions = itemWithMentions
        .replace(regStr, '<span class="user-mention">$1</span>')

    }

    const linkStr = new RegExp('(http|ftp|https):\\/\\/([\\w_-]+(?:(?:\\.[\\w_-]+)+))([\\w.,@?^=%&:\\/~+#-]*[\\w@?^=%&\\/~+#-])');

    itemWithMentions = itemWithMentions
      .replace(linkStr, `<a class="link-string" href="$&" target="_blank" rel="noopener noreferrer">$2</a>`);

    (this.el.nativeElement as HTMLElement).innerHTML = itemWithMentions
  }


}
